export default "__VITE_ASSET__BfR2CVd9__"